export default __webpack_public_path__ + "static/Shocking_Tranquilizer_Dart-c5dba2eb9c6dde56b2694167e5a8c6a5.png";